export const SET_LOCALIZATION_DATA = 'SET_LOCALIZATION_DATA';
